import type { ActionContext } from 'vuex'

import type { ActionClass, IndexState } from '../../../models'
import type { IndexJobService, IndexJobServiceJobParams } from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

export class DownloadFeedAction implements ActionClass {
  static execute(
    this: void,
    context: ActionContext<IndexState, unknown>,
    params: IndexJobServiceJobParams,
  ): Promise<string> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    return service.downloadFeed(params)
  }
}
